<!--
 * @Description:
 * @Date: 2021-06-24 14:41:26
-->
<template>
  <el-table-column
    v-if="showItem"
    :prop="item.prop"
    :label="item.label"
    :width="item.width || ''"
    :min-width="item.minWidth || ''"
    :formatter="item.formatter"
    :show-overflow-tooltip="
      item.showToolTip !== undefined ? item.showToolTip : true
    "
    :key="item.prop"
    :align="item.align || 'center'"
  >
    <template slot-scope="scope">
      <template v-if="item.render">
        <myrender
          :row="scope.row"
          :column="scope.column"
          :index="index"
          :no="scope.$index"
          :render="item.render || null"
        />
      </template>
      <template v-else>
        <span class="cell el-tooltip">
          {{
            !item.render
              ? item.formatter
                ? item.formatter(
                    scope.row,
                    scope.column,
                    scope.row[(scope.column || {}).property]
                  )
                : scope.row[(scope.column || {}).property] || '-'
              : ''
          }}
        </span>
      </template>
    </template>
  </el-table-column>
</template>

<script>
import myrender from '@/components/tableRender/myrender';

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  components: {
    myrender
  },
  computed: {
    showItem() {
      return this.item.hidden ? false : true;
    }
  }
};
</script>
